<template>
    <Modal :title="$t('customRating.editModal.title')"
           :close-on-click-outside="false"
           @close="closeModal()"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
                <md-field displayOnly>
                    <label>{{$t("common.company")}}</label>
                    <md-input :value="form.ratedCompany.companyName" disabled></md-input>
                </md-field>
                <md-field displayOnly>
                    <label>{{$t("common.vatId")}}</label>
                    <md-input :value="form.ratedCompany.taxNum" disabled></md-input>
                </md-field>
                <md-field displayOnly>
                    <label>{{$t("common.address")}}</label>
                    <md-input :value="form.ratedCompany.address" disabled></md-input>
                </md-field>
                <md-field>
                    <label>{{ $t("customRating.table.rating1") }}</label>
                    <MoneyAmountInput v-model="form.rating1"></MoneyAmountInput>
                </md-field>
                <md-field>
                    <label>{{ $t("customRating.table.rating2") }}</label>
                    <MoneyAmountInput v-model="form.rating2"></MoneyAmountInput>
                </md-field>
                <md-field>
                    <label>{{ $t("customRating.table.rating3") }}</label>
                    <MoneyAmountInput v-model="form.rating3"></MoneyAmountInput>
                </md-field>
            </form>
            <div class="flex flex_between">
                <md-button class="md-blank" @click="closeModal()">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="md-primary"
                    @click="submit"
                >{{ $t("common.button.submit") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";
import {customRatingsApi} from "@/common/api/customRatingsApi";

export default {
    components: {
        Modal,
        MoneyAmountInput,
    },
    props: {
        companyId: { type: Object }
    },
    mounted() {
		this.loadData();
    },
    data() {
        return {
            form: {
                id: null,
                companyId: null,
				ratedCompany: {
				    companyName: null,
                    taxNum: null,
                    address: null,
                },
                rating1: null,
				rating2: null,
				rating3: null,
            }
        };
    },
    methods: {
	    loadData() {
            customRatingsApi.inspection.getCustomRating(this.companyId)
                .then(res => {
                	let ratedCompany = {
						companyName: res.ratedCompany.name,
					    taxNum: res.ratedCompany.taxNum,
					    address: res.ratedCompany.street + ", " + res.ratedCompany.postcode + ", " + res.ratedCompany.city
                    };
                	this.form = {
                		id: res.id,
						rating1: res.rating1,
					    rating2: res.rating2,
					    rating3: res.rating3,
						companyId: this.companyId,
						ratedCompany: ratedCompany
                    };
                })
                .catch(e => {
					this.toast(e);
                })
	    },
        closeModal() {
            this.$emit("close");
        },
        submit() {
            this.$emit("submit", this.form)
        },
    },
};
</script>